import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";

type Props = {
  open: boolean;
  title: string;
  loading: boolean;
  checkLoading?: boolean;
  blockReasons?: string[];
  onClose: () => void;
  onCancel: (reason: string) => void;
};

const options: string[] = [
  "Konsult sjuk",
  "Kund avbokade pga förändrat behov",
  "Kund avbokade pga bristande kvalitet hos konsult",
  "Veckan flyttades"
];

const otherReason = "OTHER_REASON";

export const CancelBookingDialog: React.FC<Props> = (props) => {
  const [option, setOption] = useState<string>("");
  const [reason, setReason] = useState<string>("");

  const cancelBooking = () => {
    props.onCancel(reason);
  };

  const close = (): void => {
    setReason("");
    setOption("");
    props.onClose();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const _option = e.target.value;
    setOption(_option);
    _option !== otherReason && setReason(_option);
    _option === otherReason && setReason("");
  };

  const canSubmit = !!reason && !props.loading;

  const isBlocked = props.blockReasons && props.blockReasons.length > 0;

  return (
    <Dialog
      open={props.open}
      onClose={() => close()}
      TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
    >
      {props.checkLoading ? (
        <>
          <DialogContent style={{ display: "flex", alignItems: "center", gap: 16, padding: "24px 32px" }}>
            <CircularProgress size={20} />
            <Typography>Kontrollerar om bokningen kan avbokas...</Typography>
          </DialogContent>
        </>
      ) : isBlocked ? (
        <>
          <DialogTitle>Bokningen kan inte avbokas</DialogTitle>
          <DialogContent>
            <List dense disablePadding>
              {props.blockReasons.map((r, i) => (
                <ListItem key={i} disableGutters>
                  <ListItemText primary={`• ${r}`} />
                </ListItem>
              ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={() => close()}>
              {locale.OK}
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogTitle>{props.title}</DialogTitle>

          <DialogContent>
            <Typography variant="subtitle1">{locale.GiveCancelingReason}:</Typography>

            <RadioGroup onChange={handleChange} value={option}>
              {options.map((opt, i) => (
                <FormControlLabel key={i} control={<Radio />} label={opt} value={opt} />
              ))}

              <FormControlLabel
                control={<Radio />}
                label={locale.OtherReason}
                value={otherReason}
              />
            </RadioGroup>
            {option === otherReason && (
              <TextField
                autoFocus
                disabled={option !== otherReason}
                margin="dense"
                label={locale.Why}
                type="text"
                value={option !== otherReason ? "" : reason}
                onChange={(e) => setReason(e.target.value)}
                fullWidth
                multiline
              />
            )}
          </DialogContent>

          <DialogActions>
            <Button variant="text" onClick={() => props.onClose()}>
              {locale.No}
            </Button>

            <Button
              variant="contained"
              color="primary"
              disabled={!canSubmit}
              onClick={() => cancelBooking()}
            >
              {locale["Yes, cancel booking"]}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
